<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :options="options" @optionsupdate="memopup">
            <template v-if="isload">

                <template v-if="($common.basic.isobjexist(infolist))">
                    <div class="memcourse">
                        <div class="list" v-for="item in infolist" :key="item.id">
                            <dl v-for="item2 in item.x_children" :key="item2.id">
                                <dt><fflink linktype="image" :info="item2"></fflink></dt>
                                <dd><fflink :info="item2"></fflink> <span :class="['b','b'+item.level]">{{$common.langinfo($common.getoptiontitle(courselevel,item.level,'title'),$common.getoptiontitle(courselevel,item.level,'title_en'))}}</span></dd>

                            </dl>
                            <dl class="placeholder"></dl><dl class="placeholder"></dl><dl class="placeholder"></dl>
                        </div>
                    </div>
                </template>


                <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
            </template>

        </Cmember>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'member',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 2,
                listproject: [],
                options: {
                    hasoption: 1,
                    haslevel: 1,
                    hasdemand: 1,
                    hasproject: 1,
                    haskw: 0
                }
            };
        },
        methods: {
            getdata: function () {
                let jsondata = { 'postdata': { 'act': 'tea_my_course', 'data': { 'hasdemand': 1, 'projectid': this.myoption.projectid, 'levelid': this.myoption.levelid } } };
                this.$common.post(jsondata, res => {

                    this.$common.each(res.infodatacourse, item => {
                        item.x_url = '/course/' + item.id;
                        item.x_len = 20;
                    });


                    this.$common.each(res.infodata, item => {
                        item.x_children = this.$common.basic.fffilter(res.infodatacourse, "levelid", item.id);
                    });
                    this.infolist = res.infodata;
                    this.courselevel = res.infodatacourselevel;
                    this.isload = true;
                });
            }
        }
    }
</script>
